import ConfirmationCode from './ConfirmationCode';

export default ConfirmationCode;
